/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'mqtt': {
    width: 16,
    height: 16,
    viewBox: '0 0 272 265',
    data: '<path pid="0" d="M34.9 144h-.6v77.6c0 5.6 4.6 10.2 10.2 10.2h79.9c-.7-48.5-40.6-87.8-89.5-87.8z"/><path pid="1" d="M34.9 80h-.6v33c65.9.3 119.5 53.3 120.2 118.8h34.2C188.1 148 119.3 80 34.9 80z"/><path pid="2" d="M237.2 221.7v-70.1C214 94.8 167.3 50 109.1 29H44.5c-5.6 0-10.2 4.6-10.2 10.2V49c101.4.3 183.9 82 184.5 182.8h8.2c5.6 0 10.2-4.5 10.2-10.1zM210.5 57.3c9.4 9.4 19 21.3 26.7 31.8v-50c0-5.6-4.5-10.1-10.1-10.1h-51.5c11.9 8.3 24.3 17.8 34.9 28.3z"/>'
  }
})
